import Vue from "vue";
import Vuex from "vuex";
import { has } from "lodash-es";
import account from "./account";
import experiment from "./experiment";
import authentication from "./authentication";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    loading: false,
    error: null
  },
  getters: {
    loading: state => state.loading,
    error: state => state.error
  },
  actions: {
    clearErrors: ({ commit }) => {
      commit("clearError");
      commit("authentication/clearError");
    },
    setErrors: ({ commit }, payload) => {
      commit("setError", payload);
      commit("authentication/setError", payload);
    }
  },
  mutations: {
    setLoading: (state, payload) => (state.loading = payload),
    clearError: state => (state.error = null),
    setError: (state, payload) => {
      if (has(payload, "graphQLErrors[0].message")) {
        state.error = payload.graphQLErrors.map(e => e.message).join(", ");
      }
    }
  },
  modules: {
    account,
    experiment,
    authentication
  }
});
